
// import firebase from 'firebase';
import Vue from 'vue';
import Router from 'vue-router';

import Home from '@/views/Home';
import Landing from '@/views/Landing';
import Dashboard from '@/views/Dashboard';
import Create from '@/views/Create';
import Events from '@/views/Events';
import Meeting from '@/views/Meeting';
import EventDetail from '@/views/EventDetail';
import Privacy from '@/views/PrivacyPolicy';
import Cookie from '@/views/CookiePolicy';
import TermsOfUse from '@/views/TermsOfUse';
// import VideoCall from '@/views/VideoCall';
import AgoraVideoCall from '@/views/AgoraVideoCall';
import Signup from "@/views/Signup";
import Register from "@/views/Register";
import Verify from "@/views/Verify";
import Onboarding from '@/views/Onboarding';
import FixIssues from '@/views/FixIssues';
import Organization from "@/views/Organization";
import ResetPassword from "@/views/ResetPassword";
// import Settings from '@/views/Settings';
// import EventSetting from "../views/EventSetting";
// import QuickSetting from "@/views/QuickSetting";
import EditEventDetail from "@/components/dashboard/edit-event"
Vue.use(Router);

const router = new Router({
  mode:"history",
  base: "/",
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  },
  routes: [
    {
      path: '/',
      name: 'landing',
      component: Landing
    },
    {
      path: '/signup',
      name: 'signup',
      component: Signup
    },
    {
      path: '/password/reset',
      name: 'reset password',
      component: ResetPassword
    },
    {
      path: '/register',
      name: 'register',
      component: Register
    },
    {
      path: '/verify',
      name: 'verify',
      component: Verify
    },
    {
      path: '/event/:id',
      name: 'events',
      component: Events,
      props: true,
    },
    {
      path: '/privacy-policy',
      name: 'privacy-policy',
      component: Privacy,
      props: true,
    },
    {
      path: '/fix-issues',
      name: 'fix-issues',
      component: FixIssues,
      props: true,
    },
    {
      path: '/event/:name/:id',
      name: 'quickSetting',
      component: AgoraVideoCall,
      props: true,
    },
    {
      path: '/meetfast',
      name: 'agoraVideoCall',
      component: AgoraVideoCall,
      props: true
    },
    {
      path: '/event/:id/agenda/:session',
      name: 'event',
      component: Events,
      props: true,
    },
    {
      path: '/cookie-policy',
      name: 'cookie-policy',
      component: Cookie,
      props: true,
    },
    {
      path: '/terms-of-use',
      name: 'terms-of-use',
      component: TermsOfUse,
      props: true,
    },
    {
      path: '/meeting/:id',
      name: 'meeting',
      props: true,
      component: Meeting,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/home',
      name: 'Home',
      component: Home,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/dashboard',
      name: 'Dashboard',
      component: Dashboard,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/organization/:id',
      name: 'event',
      component: Organization,
      props: true,
    },
    {
      path: '/dashboard/create-event',
      name: 'Create',
      component: Create,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/e/:id',
      name: 'EventDetail',
      component: EventDetail,
      props: true,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/e/:id/edit',
      name: 'editEventDetail',
      component:  EditEventDetail,
      props: true,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/onboarding',
      name: 'Onboarding',
      component: Onboarding,
      props: true,
    }
  ]
});

// router.beforeEach((to, from, next) => {
//   const currentUser = firebase.auth().currentUser;
//   const requiresAuth = to.matched.some(record => record.meta.requiresAuth);
//   // if (requiresAuth && !currentUser) next('');
//   // else if (!requiresAuth && currentUser) next('home');
//   // else next();
// });

export default router;
